import React, { useState, useEffect } from "react";
import { BASE_URL } from "../utils/config";
import {  useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar";
import { Toolbar } from "primereact/toolbar";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
} from "@mui/material";
import Loading from "../components/loading";
import TelegramWidget from "../components/widget/telegramWidget";
import StockGTTable from '../components/stockGTTable'

const StockGT = () => {
 const navigate = useNavigate();
  const [GTRecord, setGTRecord] = useState([]);
  const [loading, setLoading] = useState(true);

  const [value, setValue] = useState(0);

  const [successDialog, setSuccessDialog] = useState(false);
  const [errorDialog, setErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [heading, setHeading] = useState('ADD General Trend')
  const [email,setEmail] = useState('');
  let count = 0;
 


  useEffect(() => {
    if (count === 0) {
      fetchrecord();
      const details = JSON.parse(localStorage.getItem('userdetails'));
      setEmail(details.email_address)
      count += 1;
    }
  }, []);

  //  this function is used to fetch record
  const fetchrecord = async () => {
    console.log("inside fetch record ")
    const loginuser = JSON.parse(localStorage.getItem('loginData'));
    try {
      await fetch(`${BASE_URL}/getstockgtandsr/GT`, {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${loginuser.token}`
        }
      })
        .then((response) => response.json())
        .then((res) => {
           
          if (res.status === 200) {
            console.log(
              "stock GT",
              res.data
            );

            setGTRecord(res.data);
            setHeading('ADD General Trend')
            setValue(0)

            setLoading(false);

            // console.log("lot_size",res.lot_size)
          }else if(res.status === 403){ 
            setTimeout(()=>{
              localStorage.clear()
               navigate('/login')
            },3000) 
          }
          else if(res.status === 401){
            setTimeout(()=>{
              localStorage.clear()
               navigate('/login')
            },3000) 
          } else {
            console.log("data not found");
            setLoading(false);
            setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true);
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage('')
            }, 2000);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
          setErrorMessage(`Error: ${error.message}`);
          setErrorDialog(true);
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage('')
          }, 2000);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true);
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage('')
      }, 2000);
    }
  };



  // center toolbar
  const centerToolbarTemplate = () => {
    return (
      <>
        <h2 style={{ marginTop: "0px" }}>{heading}</h2>
      </>
    );
  };

  //    hanlde update value of a record
  const handleUpdateRecordData = (id, newValue) => {
    console.log("id of a record",id)
    console.log("new value of a record",newValue)
   
  
        setGTRecord((prevData) =>
          prevData.map((item) =>
            item.id === id ? { ...item, GenralTrend: newValue } : item
          )
        );
      
   
setTimeout(() => {
    console.log("GT Record",GTRecord)
}, 2000);
   
  };


//   handle update latest record after update api
   const handleUpdateChild = ()=>{
    fetchrecord()
   }


  return (
    <>
      <Sidebar />
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
          }}
        >
          <Loading />
        </div>
      ) : (
        <div className="add-user user-list">
          <Toolbar
            className="table-pre-head"
          
            center={centerToolbarTemplate}
          ></Toolbar>
      
            <StockGTTable RecordData={GTRecord} heading={'ADD General Trend'} updaterecord={fetchrecord} updateRecordData={handleUpdateRecordData} handleUpdateChild={handleUpdateChild} Email={email}/>
       

<TelegramWidget/>

          {/*Error Message Dialog */}
          <Dialog
            open={errorDialog}
            onClose={() => { setErrorDialog(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <h4 style={{ color: "red" }}>Failure</h4>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">


                {errorMessage}


              </DialogContentText>
            </DialogContent>

          </Dialog>

          {/*Success Message Dialog */}
          <Dialog
            open={successDialog}
            onClose={() => { setSuccessDialog(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <h4 style={{ color: "green" }}>Success</h4>

            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">


                <span style={{ color: "black" }}>
                  {successMessage}
                </span>


              </DialogContentText>
            </DialogContent>

          </Dialog>

       


        </div>
      )}
    </>
  );
};

export default StockGT;
